// Pure helpers. Never include cart tokens, email, addresses or customer IDs.
const MEASUREMENT_ID = 'G-F9L9NQ6ZQH'
const CONSENT_KEY = 'selahatin:consent:v1'
const HOSTS = ['selahatin.com', 'www.selahatin.com']

function numericId (value) {
  let id = String(value || '')
  if (!id.startsWith('gid://')) {
    try { if (typeof atob === 'function') id = atob(id) } catch (_) {}
  }
  return id.split('/').pop()
}

function amount (value) {
  const number = Number(value && typeof value === 'object' ? value.amount : value)
  return Number.isFinite(number) && number >= 0 ? number : 0
}

function itemFor (variant, product = {}, quantity = 1, line = {}) {
  if (!variant || !variant.id) return null
  return {
    // Verified against this property's existing Shopify purchase item IDs (15 Oct 2026).
    item_id: product.id ? `shopify_FR_${numericId(product.id)}_${numericId(variant.id)}` : String(variant.sku || numericId(variant.id)),
    item_sku: String(variant.sku || ''),
    item_name: String(product.title || line.title || variant.title || ''),
    item_brand: 'Selahatin',
    item_category: String(product.productType || ''),
    item_variant: String(variant.title || ''),
    price: line.sellingPlan ? amount(line.sellingPlan.price) / 100 : amount(variant.price),
    quantity: Math.max(0, Number(quantity) || 0)
  }
}

function cartItems (state) {
  return [...(state.cart?.lineItems || []), ...(state.cartSubs || [])].map(line => {
    const product = (state.shopifyProducts || []).find(product => (product.variants || []).some(v => v.id === line.variant?.id))
    return itemFor(line.variant, product, line.quantity, line)
  }).filter(Boolean)
}

function cartSnapshot (state) {
  return {
    id: state.cart?.id || '',
    currency: state.cart?.currencyCode || state.shopInfo?.currencyCode || 'EUR',
    items: cartItems(state).map(item => ({ ...item }))
  }
}

function cartDeltas (before, after) {
  if (!before?.id || before.id !== after.id) return []
  const group = snapshot => snapshot.items.reduce((map, item) => {
    const key = `${item.item_id}|${item.item_variant}|${item.price}`
    map[key] = { ...item, quantity: (map[key]?.quantity || 0) + item.quantity }
    return map
  }, {})
  const oldItems = group(before)
  const newItems = group(after)
  const events = []
  new Set([...Object.keys(oldItems), ...Object.keys(newItems)]).forEach(key => {
    const difference = (newItems[key]?.quantity || 0) - (oldItems[key]?.quantity || 0)
    if (!difference) return
    const item = { ...(difference > 0 ? newItems[key] : oldItems[key]), quantity: Math.abs(difference) }
    events.push({ name: difference > 0 ? 'add_to_cart' : 'remove_from_cart', params: ecommerce([item], after.currency) })
  })
  return events
}

function ecommerce (items, currency) {
  return { currency, value: Math.round(items.reduce((total, item) => total + item.price * item.quantity, 0) * 100) / 100, items }
}

function productionAllowed (location, cookie = '') {
  return HOSTS.includes(location.hostname) && !/^\/preview(?:\/|$)/.test(location.pathname || '') && !cookie.includes('io.prismic.preview') && !/\b(?:preview|debug_mode|analytics_debug)=/i.test(location.search || '')
}

function safeLocation (href) {
  const url = new URL(href)
  if (!['https:', 'http:'].includes(url.protocol)) return ''
  const retained = new URLSearchParams()
  ;['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', '_gl'].forEach(key => {
    if (url.searchParams.has(key)) retained.set(key, url.searchParams.get(key))
  })
  return url.origin + url.pathname + (retained.toString() ? '?' + retained.toString() : '')
}

module.exports = { MEASUREMENT_ID, CONSENT_KEY, HOSTS, numericId, amount, itemFor, cartItems, cartSnapshot, cartDeltas, ecommerce, productionAllowed, safeLocation }
